import React, { useCallback } from "react";
import "./NumberInput.css";
import debounce from "lodash.debounce";

const NumberInput = ({
  label,
  postLabel,
  onChange,
  value,
  min,
  max,
  onFocusOut,
  disabled,
  step,
  key,
  customBtnMargin
}) => {
  const debouncedFocusOut = useCallback(
    debounce(onFocusOut ? onFocusOut : () => {}, 1000),
    []
  );
  const handleInc = () => {
    if (disabled || !onChange) return;
    if (!isNaN(max)) {
      if (value < max) {
        onChange(Number(value) + 1);
        debouncedFocusOut();
      }
    } else {
      onChange(Number(value) + 1);
      debouncedFocusOut();
    }
  };

  const handleDec = () => {
    if (disabled || !onChange) return;
    if (!isNaN(min)) {
      if (value > min) {
        onChange(Number(value) - 1);
        debouncedFocusOut();
      }
    } else {
      onChange(Number(value) - 1);
      debouncedFocusOut();
    }
  };
  return (
    <div className="numContainer">




      {label && <span className="number-label">{label}</span>}


      <div className={"numContainer-component " + (disabled ? "disabled" : "")} style={window.innerWidth >= 1440 ? customBtnMargin : null}>

        <div className="btnContainer">

          <div onClick={handleInc} className="top-btn">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="icon-tabler icon-tabler-chevron-up"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              stroke-width="2"
              stroke="currentColor"
              fill="none"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
              <polyline points="6 15 12 9 18 15"></polyline>
            </svg>
          </div>
          <div onClick={handleDec} className="down-btn">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="icon-tabler icon-tabler-chevron-down"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              stroke-width="2"
              stroke="currentColor"
              fill="none"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
              <polyline points="6 9 12 15 18 9"></polyline>
            </svg>
          </div>

        </div>


        <span className="inputContainer">
          <input
            type="number"
            class="form-controlRender"
            value={value}
            step={step}
            min={min}
            max={max}
            key={key}
            onChange={(evt) => {
              if (onChange) {
                onChange(evt.target.value);
              }
            }}
            onBlur={onFocusOut}
            disabled={disabled}
            readOnly
          />
          {postLabel && <span className="postLValue">{postLabel}</span>}
        </span>
      </div>
    </div>
  );
};

export default NumberInput;